var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.page ? _c('div', [_c('vue-title', {
    attrs: {
      "title": "Events - Whoosh! Your Indoor Cycling Solution"
    }
  }), _c('section', {
    staticClass: "event-main events-page-wrap clearfix"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "myTabContent"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade",
    class: {
      'show active': _vm.$route.query.event !== 'dailyrides'
    },
    attrs: {
      "id": "upcoming",
      "aria-labelledby": "upcoming-tab",
      "role": "tabpanel"
    }
  }, [_vm.featuredEvents.length > 0 ? _c('EventList', {
    attrs: {
      "events": _vm.featuredEvents
    }
  }) : _vm._e(), _vm.allEvents.length > 0 ? _c('EventList', {
    attrs: {
      "events": _vm.allEvents
    }
  }) : _vm._e()], 1)])])])])])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }